<template>
    <img class="banner-img" :src="articleDetail.blogPic"/>

</template>
<script>
import api from "../api/api";

export default {
  name: 'topImgBanner',
  components: {},
  //menu  主要需要typeId
  props: {
    typeId: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      tags: [],
      activeName: '',
      articleDetail: {}
    }
  },
  watch: {
    typeId: {
      handler(newVal) {
        this.getData()
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.articleDetail = {}
      api.getAriticle({language: this.$store.state.lang, typeId: this.typeId}).then(res => {
        let list = res.data.data
        if (list && list.length > 0) {
          this.articleDetail = list[0]
        }
      })
    }
  }
}
</script>
<style scoped>
.banner-img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/topImgBanner.vue